import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { 
  initializeAnalytics, 
  trackPageView, 
  getCurrentUTMParams 
} from '../services/analytics';

/**
 * Hook for automatic page view tracking with React Router
 * Initializes analytics on mount and tracks route changes
 */
export const usePageTracking = () => {
  const location = useLocation();

  // Initialize analytics on first mount
  useEffect(() => {
    initializeAnalytics();
  }, []);

  // Track page views on route changes
  useEffect(() => {
    const pagePath = location.pathname + location.search;
    const pageTitle = document.title;
    
    // Small delay to ensure page title is updated
    const timeoutId = setTimeout(() => {
      trackPageView(pagePath, pageTitle, {
        route_name: location.pathname,
        search_params: location.search
      });
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [location]);
};

/**
 * Hook to get current UTM parameters
 * @returns {Object} Current UTM parameters
 */
export const useUTMParams = () => {
  return getCurrentUTMParams();
};

/**
 * Hook for analytics utilities
 * @returns {Object} Analytics helper functions
 */
export const useAnalytics = () => {
  const utmParams = useUTMParams();
  
  return {
    utmParams,
    getCurrentUTMParams
  };
};
